import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
    children: ReactNode;
};

const Cards = (props: Props) => {
    return (
        <CordWrapper className='dashBoard'>
            {props.children || ''}
        </CordWrapper>
    );
};

const CordWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`

export default Cards;